import {Maybe, User} from '@cp/model';
import {adminTabs} from '../pages/admin/adminTabs';
import {filterTabs} from '../pages/admin/filterTabs';
import {PrivateRouteProps, RouteType} from './routeType';

export function routeAdmin(user?: Maybe<User>): RouteType<PrivateRouteProps>[] {
  // Filter tabs based on user permissions
  const accessibleTabs = filterTabs(adminTabs, user?.roles);

  // If user has no access, return empty array
  if (accessibleTabs.length === 0) {
    return [];
  }

  // Find the first non-parameterized route for the default /admin route
  const defaultTab = accessibleTabs.find((tab) => !tab.path.includes(':'));
  const defaultComponent = defaultTab?.component || accessibleTabs[0]?.component;

  return [
    // Index route - default to first accessible non-parameterized tab
    ...(defaultComponent
      ? [
          {
            path: '/admin',
            component: defaultComponent,
          },
        ]
      : []),
    // All accessible routes (including parameterized routes)
    ...accessibleTabs.map((tab) => ({
      path: tab.path,
      component: tab.component,
    })),
  ];
}
